import React from 'react'
import { observer } from 'mobx-react-lite'
import { ProgressBar } from '../ProgressBar'

export interface PlayerCellProgressBarProps {
  duration: number
  maxDuration: number
}

export const PlayerCellProgressBar = observer(({ duration, maxDuration }: PlayerCellProgressBarProps) => {
  return (
    <ProgressBar
      duration={duration}
      maxDuration={maxDuration}
      color="Global/White"
      backgroundColor="Global/Black"
      backgroundOpacity={0.5}
    />
  )
})
